<template>
    <div class="body-box" v-track="{ event: 'browse', route: $route, isButton: false }">
        <div style="margin-bottom: 10px">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/home' }"><span
                        style="color: #000000;font-weight: 500;">首页</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/Empowerment/pledge/houseProperty/rapidValuation' }"><span
                        style="color: #000000;font-weight: 500;">单套估价</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span style="color: #045AFC">历史记录</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main-content">
            <div class="filter-box">
            <Row index="">
                <Col span="24">
                <Form ref="getHistoryForm" :model="getHistoryForm" label-position="right" :label-width="70" inline>
                    <FormItem label="城市" :label-width="70" style="margin-right: 28px;">
                        <Select v-model="getHistoryForm.cityCode" clearable style="width:200px;" filterable>
                            <Option v-for="item in cityList" :value="item.cityCode" :key="item.cityCode">{{
                                item.cityName }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="小区" :label-width="70" style="margin-right: 28px;">
                        <Input type="text" maxlength="50" style="width:200px;" v-model="getHistoryForm.lpName"
                            placeholder="请输入">
                        </Input>
                    </FormItem>
                    <FormItem label="估价对象" :label-width="70" style="margin-right: 28px;">
                        <Input type="text" maxlength="50" style="width:200px;" v-model="getHistoryForm.evlTitle"
                            placeholder="请输入">
                        </Input>
                    </FormItem>
                    <FormItem label="出值状态" :label-width="70" style="margin-right: 28px;">
                        <Select v-model="getHistoryForm.assessResult" clearable style="width:200px;">
                            <Option v-for="item in statusList" :value="item.value" :key="item.value">{{
                                item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="提交时间" :label-width="70" style="margin-right: 28px;">
                        <DatePicker :options="dataLimit2" format="yyyy-MM-dd" type="daterange" placement="bottom-end"
                            style="width:200px;" @on-change='getHistorySelectDate' placeholder="请选择"></DatePicker>
                    </FormItem>
                    <FormItem :label-width="12">
                        <Button type="primary " style="margin-right: 10px;" @click="getHistory(1)">查询</Button>
                        <Button type="primary" @click="downloadHistory">下载</Button>
                    </FormItem>
                </Form>
                </Col>
                <Col span="">
                </Col>
            </Row>
            </div>
            <div class="table-box">
                <Table :columns="columns" stripe :data="Mydata" v-loading="isLoading">
                    <template slot-scope="{ row }" slot="evlTitle">
                        <Tooltip max-width="400" :transfer="true">
                            <div class="evlTitle-box" @click="goResult(row)">
                                <div class="red-point" v-if="row.hasRedPoint"></div>
                                {{ row.evlTitle | filter_evlTitle }}
                            </div>
                            <div slot="content">
                                <div>{{ row.evlTitle }}</div>
                            </div>
                        </Tooltip>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <Poptip confirm placement="bottom" width="300" :transfer="true" title="确定删除?"
                            @on-ok="remove(row)" @on-cancel="cancel">
                            <!-- <img src="../assets/images/delete_icon.png" alt="" style="width: 16px; height: 16px; cursor: pointer;"> -->
                            <span style="display: inline-flex; align-items: center; cursor: pointer;">
                                <img src="~@/assets/image/delete_icon.png" alt=""
                                    style="width: 14px; height: 14px; cursor: pointer; margin-top: -2px; vertical-align: middle; margin-right: 2px;">
                                <span style="cursor: pointer;">删除</span>
                            </span>
                        </Poptip>
                    </template>
                </Table>
            </div>
            <div class="pager-row">
            <Row style="margin-top: 24px;" type="flex" justify="space-between">
                <div style="line-height: 28px;">显示第
                    <span style="color: #045afc;">{{ startNum }} </span>
                    到第
                    <span style="color: #045afc;">{{ endNum }} </span>
                    条记录，总共
                    <span style="color: #045afc;">{{ totalPage }} </span>
                    条记录
                </div>
                <el-pagination background layout="sizes, prev, pager, next, jumper"
                    :current-page="getHistoryForm.current" :page-size="getHistoryForm.size" :total="totalPage"
                    @size-change="handleSizeChange" @current-change="currentChange">
                </el-pagination>
            </Row>
            </div>
        </div>
    </div>
</template>

<script>
import { evaluationHistoryPage, delEvaluationHistory, getEvlHisCity, evaluationHistoryDown } from '@/api/pledge'
import dayjs from 'dayjs'

import {
    formatTime,
    formatDate,
    _debounce
} from "@/utils/";
import dataReports from "@/mixins/dataReports";
import { status } from 'nprogress';
import util from "@/utils/utils2";

export default {
    mixins: [dataReports],

    data() {
        return {
            // cityList: [
            //     { label: '全部', value: 0 },
            //     { label: '广州市', value: '440100' },
            //     { label: '佛山市', value: '440600000000' },
            //     { label: '东莞市', value: '441900000000' },
            // ],
            statusList: [
                { label: '已出值', value: 1 },
                { label: '暂无估价', value: 2 },
                { label: '估价中', value: 0 },
            ],
            cityList: [],
            getHistoryForm: {
                cityCode: 0,
                evlTitle: '',
                assessTimeStart: '',
                assessTimeEnd: '',
                current: 1,
                size: 10,
                evaluationIsBatch: 0,
            },
            totalPage: 0,
            //时间限制
            dataLimit2: {
                disabledDate(date) {
                    return (
                        date.valueOf() > Date.now()
                    );
                },
            },
            columns: [
                {
                    title: '序号',
                    key: "index",
                    minWidth: 100,
                    fixed: 'left'
                },
                {
                    title: '城市',
                    key: 'cityFullName',
                    minWidth: 140,
                    tooltip: true
                },
                {
                    title: '估价对象',
                    key: 'evlTitle',
                    minWidth: 260,
                    tooltip: true,
                    slot: 'evlTitle',

                },
                {
                    title: '小区',
                    key: 'lpName',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    title: '面积（㎡）',
                    key: 'buildingArea',
                    minWidth: 120,
                    render(h, params) {
                        return h(
                            "span",
                            params.row.buildingArea ? (params.row.buildingArea * 1).toFixed(2) : '暂无数据'
                        );
                    },
                },
                {
                    title: '单价（元/㎡） ',
                    key: "evlUnitPrice",
                    minWidth: 140,
                    render: (h, params) => {
                        let text = ''
                        switch (params.row.assessResult) {
                            case 0:
                                text = ''
                                break;
                            case 1:
                                text = (params.row.evlUnitPrice * 1).toFixed(0)
                                break;
                            case 2:
                                text = '--'
                                break;
                            case 3:
                                text = (params.row.evlUnitPrice * 1).toFixed(0)
                                break;

                            default:
                                break;
                        }
                        return h(
                            "span",
                            text
                        );
                    },
                },
                {
                    title: "总价（万元）",
                    key: "evlTotalPrice",
                    minWidth: 140,
                    render: (h, params) => {
                        let text = ''
                        switch (params.row.assessResult) {
                            case 0:
                                text = ''
                                break;
                            case 1:
                                text = (params.row.evlTotalPrice * 1).toFixed(2)
                                break;
                            case 2:
                                text = '--'
                                break;
                            case 3:
                                text = (params.row.evlTotalPrice * 1).toFixed(2)
                                break;

                            default:
                                break;
                        }
                        return h(
                            "span",
                            text
                        );
                    },
                },
                {
                    title: '出值状态',
                    key: 'assessResult',
                    minWidth: 120,
                    render: (h, params) => {
                        let text = ''
                        let color = ''
                        let bg = ''
                        switch (params.row.assessResult) {
                            case 0:
                                text = '估价中'
                                color = '#FA8C16'
                                bg = '#FFF7E6'
                                break;
                            case 1:
                                text = '已出值'
                                color = '#00B36B'
                                bg = '#E6F7F0'
                                break;
                            case 2:
                                text = '暂无估价'
                                color = '#FF4D4F'
                                bg = '#FFF1F0'
                                break;
                            case 3:
                                text = '已出值'
                                color = '#00B36B'
                                bg = '#E6F7F0'
                                break;
                            default:
                                break;
                        }
                        return h(
                            "span",
                            {
                                style: {
                                    display: 'inline-block',
                                    padding: '2px 10px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    lineHeight: '20px',
                                    color: color,
                                    background: bg,
                                }
                            },
                            text
                        );
                    },
                },
                {
                    title: '提交时间',
                    key: "createTime",
                    minWidth: 180,
                    render: (h, params) => {
                        return h(
                            "span",
                            dayjs(params.row.createTime).format('YYYY/MM/DD')

                        );
                    },
                },
                {
                    title: '操作',
                    slot: 'action',
                    minWidth: 100,
                },
            ],
            isLoading: false,
            Mydata: [
            ]
        };
    },
    filters: {
        filter_evlTitle(val) {
            let texts = ''
            if (val.length > 24) {
                texts = val.substring(0, 24) + '...' // 进行数字截取或slice截取超过长度时以...表示
            } else {
                texts = val
            }
            return texts;
        }
    },
    computed: {
        // 分页起始序号
        startNum() {
            if (!this.totalPage) return 0
            return (this.getHistoryForm.current - 1) * this.getHistoryForm.size + 1
        },
        // 分页结束序号
        endNum() {
            if (!this.totalPage) return 0
            const end = this.getHistoryForm.current * this.getHistoryForm.size
            return end > this.totalPage ? this.totalPage : end
        },
    },
    created() {

    },
    mounted() {
        this.getHistory(1)
        this.getCityList()
    },
    methods: {

        async getCityList() {
            let params = {
                isBatch: 0 //0:单个估价 1:批量估价
            }
            let res = await getEvlHisCity(params)
            this.cityList = res
        },
        goResult(row) {

            this.$router.push({
                path: '/Empowerment/pledge/houseProperty/resultValuation',
                query:
                {
                    cityCode: row.cityCode,
                    sampleHistoryId: row.historyId,
                    taskDetailId:row.taskDetailId
                }
            })
        },
        //日期选择后的函数
        getHistorySelectDate(date) {
            this.getHistoryForm.assessTimeStart = date[0]
            this.getHistoryForm.assessTimeEnd = date[1]
        },
        async downloadHistory() {
            const loading = this.$loading({
                lock: true,
                text: "准备下载...",
            });

            let params = Object.assign({}, this.getHistoryForm)
            if (params.cityCode == 0) {
                params.cityCode = null
            }
            try {
                let res = await evaluationHistoryDown(params);
                loading.close();

                if (res.hasOwnProperty("headers")) {
                    this.$msg.success({
                        text: "文件正在下载中，详情请看下载列表",
                        duration: 3000,
                    });
                    util.downloadBlod(res);
                } else {
                    let blob = new Blob([res]);
                    blob.text().then((errorMsg) => {
                        this.$msg.error({ text: errorMsg });
                    });
                }
            } catch (error) {
                loading.close();
                this.$msg.error({ text: "下载失败，请稍后重试" });
            }
        },
        //获取历史
        async getHistory(current) {
            this.isLoading = true
            this.getHistoryForm.current = current
            let params = Object.assign({}, this.getHistoryForm)
            if (params.cityCode == 0) {
                params.cityCode = ''
            }

            let data = await evaluationHistoryPage(params)
            this.Mydata = data.records.map((item, index) => {
                item.index = (index + 1) + this.getHistoryForm.current * 10 - 10
                return item
            })
            this.isLoading = false
            this.getHistoryForm.current = data.current
            this.totalPage = data.total
        },
        handleSizeChange(val) {
            this.getHistoryForm.size = val
            this.getHistory(1)
        },
        currentChange(page) {
            this.getHistory(page)
        },
        async remove(row) {//删除
            let params = {
                id: row.historyId,
                cityCode: row.cityCode
            }
            let res = await delEvaluationHistory(params)
            if (res) {
                this.$msg.success({ text: "删除成功" });
                this.getHistory(1)
            } else {
                this.$msg.error({ text: "删除失败" });

            }
        },
        cancel() {//删除取消

        },
    }
};
</script>

<style scoped lang="scss">
// /deep/ .ivu-select-selection, .ivu-input{
//   background: #F5F6FC;
//   border: 0;


// }
/deep/ .ivu-input {
    background: #F5F6FC;
    border: 0;

}

.body-box {
    // background: #EFF1F6;
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 1200px;
    overflow: hidden;

    .main-content {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        padding: 24px;
        overflow: auto;

        .filter-box {
            flex: none;
        }

        // .table-box {
        //     flex: 1;
        //     min-height: 0;
        //     overflow: auto;

        //     /deep/ .ivu-table-header {
        //         position: sticky;
        //         top: 0;
        //         z-index: 10;
        //         background: #fff;
        //     }
        // }

        .pager-row {
            flex: none;
        }
    }

    .evlTitle-box {
        font-family: PingFangSC-Regular-, PingFangSC-Regular;
        font-weight: normal;
        color: #045AFC;
        cursor: pointer;

        .red-point {
            background: red;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            float: left;
            position: absolute;
            left: -13px;
            top: 5px;

        }
    }
}
</style>
